import React, { useContext, useState } from 'react'

type AirdropScreen = 'default' | 'landing' | 'tasks'

interface AirdropContextType {
  screen: AirdropScreen
  setScreen: (screen: AirdropScreen) => void
}

const AirdropContext = React.createContext<AirdropContextType>({
  screen: 'default',
  setScreen: () => {}
})

const AirdropProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [screen, setScreen] = useState<AirdropContextType['screen']>('default')

  return <AirdropContext.Provider value={{ screen, setScreen }}>{children}</AirdropContext.Provider>
}

const useAirdrop = () => {
  return useContext(AirdropContext)
}

export { AirdropProvider, useAirdrop }
